import { useEffect, useState } from 'react';

/**
 * Returns a boolean to denote if the code is running on the client side.
 */
export default function useClientSide() {
  const [isClientSide, setClientSide] = useState(false);

  useEffect(() => {
    setClientSide(true);
  }, []);

  return isClientSide;
}
